import { GET_OFFLINE_COUPONS, GET_OFFLINE_COUPONS_SUCCESS, GET_OFFLINE_COUPONS_ERROR, SET_SELECTED_COUPON, USE_OFFLINE_COUPONS, USE_OFFLINE_COUPONS_ERROR, SHOW_OFFLINE_COUPON_CONTENT } from '../../constants';
const initialState = {
    isLoading: false,
    selectedCouponId: '',
    couponsList: [],
    showOfflineContent: false
};
const offlineCouponsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OFFLINE_COUPONS:
            return {
                ...state,
                isLoading: true,
            };
        case GET_OFFLINE_COUPONS_SUCCESS:
            const List = action?.payload;
            return {
                ...state,
                isLoading: false,
                couponsList: List
            };
        case GET_OFFLINE_COUPONS_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case SET_SELECTED_COUPON:
            const couponId = action?.selectedCouponId;
            return {
                ...state,
                selectedCouponId: couponId
            };
        case USE_OFFLINE_COUPONS:
            return {
                ...state,
                isLoading: true,
            };
        case USE_OFFLINE_COUPONS_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case SHOW_OFFLINE_COUPON_CONTENT:
            const showCoupons = action?.showOfflineContent;
            return {
                ...state,
                showOfflineContent: showCoupons
            };
        default:
            return state;
    }
};
export default offlineCouponsReducer;
